import type React from "react"

interface RecentUsersListProps {
  recentUsers: any[]
  t: (key: string) => string
}

export const RecentUsersList: React.FC<RecentUsersListProps> = ({ recentUsers, t }) => {
  if (recentUsers.length === 0) return null

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800">{t("user_chat")}</h3>
      <ul className="mt-2 space-y-2">
        {recentUsers.slice(-1).map((user: any) => (
          <li key={user.id} className="p-2 border rounded-md bg-white shadow-sm">
            <div className="flex items-center">
              <div className="flex-grow">
                <h4 className="font-bold text-gray-900">{user.user.name}</h4>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
